import './Birthday.scss'
import React, { useEffect } from 'react'
import { Carousel } from 'primereact/carousel'
import { useGetBirthdaysMutation } from '../../../../services/birthday/birthdays'
import { Skeleton } from 'primereact/skeleton'
import { ReactComponent as BirthdayIcon } from './assets/Birthday.svg'

const Birthday = () => {
    const [getBirthDay, { data: birthdayDataFromBackend = [], isLoading }] = useGetBirthdaysMutation()

    useEffect(() => {
        getBirthDay()
    }, [getBirthDay])
    
    const itemTemplate = (item) => {
        return (
            <div>
                <p className='Fullname text-base text-white font-semibold m-0'>{item.firstName} {item.lastName}</p>
                <p className='GrayText text-xs font-medium m-0'>{item.designation}</p>
            </div>
        )
    }
    
    const carousel = (
        <Carousel value={birthdayDataFromBackend} numScroll={1} circular showNavigators={birthdayDataFromBackend?.length>1?true:false} className='h-full' contentClassName='justify-content-center h-full'
            autoplayInterval={3000} itemTemplate={itemTemplate} />
    )
    const noDataDisplay = (
        <div className="GrayText text-sm font-medium pt-5 pl-2 md:pt-3 ">No birthday parties today ☹️</div>
    )
    let toDisplay = null

    if (birthdayDataFromBackend?.length > 0 && !isLoading) {
      toDisplay = carousel
    }else{
      toDisplay = noDataDisplay      
    }

    const skeletonPart = (
        <div>
            <Skeleton height='1.5rem' className='SkeletonColor mb-2 w-7' />
            <Skeleton height='1rem' className='SkeletonColor mb-2 w-7' />
            <Skeleton height='1rem' className='SkeletonColor mb-2 w-7' />
        </div>
    )



    return (
        <div className='Birthday w-full h-full p-3 relative overflow-hidden'>
            <div className="CarouselCard h-full flex flex-column justify-content-between">
                <h2 className="m-0 font-semibold text-base text-white">Birthdays</h2>
                {isLoading && skeletonPart}
                {!isLoading && toDisplay}
            </div>
          
            <BirthdayIcon className='BirthDayimg absolute  '/>
        </div>
    )
}

export default Birthday